import { Switch, Route } from "react-router-dom";
import {
  Home,
} from "./pages";
import { NotFound } from "./pages/notfound";

const paths = {
  home: "/",
};

export const routes = {
  ...paths,
};

const Router = () => {
  return (
    <Switch>
      <Route path={paths.home} exact component={Home} />
      <Route component={NotFound} />
    </Switch>
  );
};

export default Router;
